import React from "react";
const RenderIf = ({ condition, children }) => {
  if (condition) {
    return children;
  }
  return false;
};

export default RenderIf;
